module.exports = __webpack_public_path__ + "img/组 1.ea6e6d2b.webp";